import { maskToken } from '../../DeveloperDashboard/helpers/maskToken'
import type { SetupStep, SetupStepItem } from '../integrationConfig'

const API_KEY_PLACEHOLDER = 'API_KEY'

function transformStepItem(
  item: SetupStepItem,
  apiKey: string,
  maskedKey: string,
): SetupStepItem {
  if (typeof item === 'string') {
    return item.replaceAll(API_KEY_PLACEHOLDER, maskedKey)
  }
  return {
    ...item,
    text: item.text.replaceAll(API_KEY_PLACEHOLDER, maskedKey),
    displayText:
      item.displayText?.replaceAll(API_KEY_PLACEHOLDER, maskedKey) ??
      item.copyText?.replaceAll(API_KEY_PLACEHOLDER, maskedKey),
    copyText: item.copyText?.replaceAll(API_KEY_PLACEHOLDER, apiKey),
  }
}

export function injectApiKeyIntoStep(
  step: SetupStep,
  apiKey: string | null,
): SetupStep {
  if (!apiKey) return step

  const maskedKey = maskToken(apiKey)
  const transformedStep: SetupStep = { ...step }

  if (step.code) {
    // Display: masked key, Copy: full key
    transformedStep.code = step.code.replaceAll(API_KEY_PLACEHOLDER, maskedKey)
    transformedStep.copyCode = step.code.replaceAll(API_KEY_PLACEHOLDER, apiKey)
  }

  if (step.windowsCode) {
    transformedStep.windowsCode = step.windowsCode.replaceAll(
      API_KEY_PLACEHOLDER,
      maskedKey,
    )
    transformedStep.windowsCopyCode = step.windowsCode.replaceAll(
      API_KEY_PLACEHOLDER,
      apiKey,
    )
  }

  if (step.items) {
    transformedStep.items = step.items.map((item) =>
      transformStepItem(item, apiKey, maskedKey),
    )
  }

  // Remove note if it mentions API_KEY (since we've injected it)
  if (step.note?.includes(API_KEY_PLACEHOLDER)) {
    transformedStep.note = undefined
  }

  return transformedStep
}

export function injectApiKeyIntoSteps(
  steps: SetupStep[],
  apiKey: string | null,
): SetupStep[] {
  return steps.map((step) => injectApiKeyIntoStep(step, apiKey))
}
